//people reducer types
export const LOADING_TIMESHEET = "LOADING_TIMESHEET";
export const LOADING_TIMESHEET_SUCCESS = "LOADING_TIMESHEET_SUCCESS";

export const LOAD_TIMESHEET = "LOAD_TIMESHEET";
export const FETCH_TIMESHEET_REQUEST = "FETCH_TIMESHEET_REQUEST";
export const FETCH_TIMESHEET_REQUEST_SUCCESS =
  "FETCH_TIMESHEET_REQUEST_SUCCESS";
export const TIMESHEET_SAVE_REQUEST = "TIMESHEET_SAVE_REQUEST";
export const TIMESHEET_SAVE_SUCCESS = "TIMESHEET_SAVE_SUCCESS";
export const PROFILE_SAVE_REQUEST = "PROFILE_SAVE_REQUEST";
export const PROFILE_SAVE_SUCCESS = "PROFILE_SAVE_SUCCESS";
export const TIMESHEET_EMPLOYEE_NAME_LIST = "TIMESHEET_EMPLOYEE_NAME_LIST";
export const TIMESHEET_SCHEDULE_LIST = "TIMESHEET_SCHEDULE_LIST";
export const CLEAR_TIMESHEET_SCHEDULE_LIST = "CLEAR_TIMESHEET_SCHEDULE_LIST";
export const LOAD_TIMESHEET_INVOICES = "LOAD_TIMESHEET_INVOICES";
export const LOAD_TIMESHEET_PAYROLLS = "LOAD_TIMESHEET_PAYROLLS";
export const LOAD_TIMESHEET_REGIONS = "LOAD_TIMESHEET_REGIONS";
export const LOAD_REQUESTED_PAYROLL_TIMESHEETS =
  "LOAD_REQUESTED_PAYROLL_TIMESHEETS";

export const TIMESHEET_EMPLOYEE_FACILITIES = "TIMESHEET_EMPLOYEE_FACILITIES";
export const SET_IS_ADD_TIMESHEET_CONFIRM_DIALOG_OPEN =
  "SET_IS_ADD_TIMESHEET_CONFIRM_DIALOG_OPEN ";

export const REPLACE_SELECTED_TIMESHEET_PAYROLL =
  "REPLACE_SELECTED_TIMESHEET_PAYROLL";
export const REPLACE_SELECTED_TIMESHEET_INVOICE =
  "REPLACE_SELECTED_TIMESHEET_INVOICE";
export const REPLACE_SELECTED_TIMESHEET_REGION =
  "REPLACE_SELECTED_TIMESHEET_REGION";
export const RESTORE_TIMESHEETS = "RESTORE_TIMESHEETS";
